import { FC, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { useReferrer } from 'src/hooks/use-referrer2';
import { useTrade } from 'src/pages/reporting/my-transactions/trades/allocation-to-balancing-groups/use-trade';

const DetailsPage = lazy(() => import('./details/page'));
const AddPage = lazy(() => import('./add/page'));
const EditPage = lazy(() => import('./edit/page'));

export const TradeAllocationToBalancingGroups: FC = () => {
  const capacityManagementRoot = useCapacityManagementRoot();
  const trade = useTrade({ capacityManagementRoot });
  const referrer = useReferrer({
    label: 'My Transactions',
    location: '/reporting/my-transactions',
  });

  // avoid pop in of page titles in case of 401s
  if (!capacityManagementRoot.response) return <PageSpinner />;

  return (
    <Switch>
      <Route
        exact
        path="/reporting/my-transactions/trades/:id/allocation-to-balancing-groups/:direction(exit|entry)/:balancingGroupAllocationId/edit"
      >
        <EditPage
          trade={trade}
          capacityManagementRootResponse={capacityManagementRoot.response.data}
        />
      </Route>

      <Route
        exact
        path="/reporting/my-transactions/trades/:id/allocation-to-balancing-groups/:direction(exit|entry)/add"
      >
        <AddPage
          trade={trade}
          capacityManagementRootResponse={capacityManagementRoot.response.data}
        />
      </Route>

      <Route
        exact
        path="/reporting/my-transactions/trades/:id/allocation-to-balancing-groups/:direction(exit|entry)"
      >
        <DetailsPage
          trade={trade}
          capacityManagementRootResponse={capacityManagementRoot.response.data}
        />
      </Route>

      <Route
        path="/reporting/my-transactions/trades/:id/allocation-to-balancing-groups"
        exact
      >
        {!trade.response ? (
          <PageSpinner />
        ) : trade.response.data.exit &&
          trade.response.data.exit._links?.balancingGroupAllocations?.href ? (
          <Redirect
            to={referrer.attachTo({
              pathname: `/reporting/my-transactions/trades/${trade.response.data.id}/allocation-to-balancing-groups/exit`,
            })}
          />
        ) : (
          <Redirect
            to={referrer.attachTo({
              pathname: `/reporting/my-transactions/trades/${trade.response.data.id}/allocation-to-balancing-groups/entry`,
            })}
          />
        )}
      </Route>

      <ThrowNotFound />
    </Switch>
  );
};
